import React from "react";
import { useLanguage } from "../Context/LanguageContext";

const Header = () => {
  const { t } = useLanguage();

  return (
    <header id="header">
      <video
        className="header-video"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="/images/background-poster.jpg"
        aria-hidden="true"
      >
        <source src="/images/background.mp4" type="video/mp4" />
      </video>
      <div className="header-overlay" aria-hidden="true"></div>
      <div className="banner">
        <div className="banner-text">
          <img
            className="headerLogo"
            src="images/logo.png"
            alt="KTGPB Logo"
            style={{ maxWidth: "100%", height: "auto", marginBottom: "2rem" }}
          />
          <br />
          <a
            className="button primary"
            href="https://forms.gle/y6pgL7uZ1LJJv5tD8"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("header.join")}
          </a>
        </div>
        <p className="scrolldown">
          <a className="smoothscroll" href="#hakkimizda">
            <i className="fa fa-chevron-down" aria-hidden="true"></i>
          </a>
        </p>
      </div>
    </header>
  );
};

export default Header;
